<template>
  <div class="mc-download__list-item">
    <div class="mc-download__list-item-wrapper d-flex">
      <i class="mc-fa icon-fill_videorecord"></i>
      <div class="mc-download__list-item-text">
        <p
          :title="`${licensePlate} ${convertedChannel} - ${momentDMYH(
            convertUtcToLocalDate(startTime, deviceTimezone)
          )} - ${momentDMYH(convertUtcToLocalDate(endTime, deviceTimezone))}`"
        >
          {{ licensePlate }} {{ convertedChannel }} -
          {{ momentDMYH(convertUtcToLocalDate(startTime, deviceTimezone)) }}
          -
          {{ momentDMYH(convertUtcToLocalDate(endTime, deviceTimezone)) }}
        </p>
        <p>
          <span>
            {{ $t('videoHistory.widgetDownload.downloadTime') }}
            {{ momentDMYH(downloadOn) }}
          </span>
        </p>
      </div>
    </div>
    <b-row class="mt-2 mc-download__list-item-button">
      <b-col md="6">
        <McButton
          class="mc-download-video__button-wrapper"
          icon="icon-outline_play-circle"
          :text="$t('videoHistory.widgetDownload.watchVideo')"
          @click="handleClickShowVideo"
        />
      </b-col>
      <b-col md="6">
        <a
          v-if="isVideoDemo"
          :href="url"
          download
          class="btn btn-primary mc-button__download-video-history"
        >
          <i class="mc-fa icon-outline_download" />
          {{ $t('videoHistory.widgetDownload.download') }}
        </a>
        <McButton
          v-else
          class="mc-download-video__button-wrapper"
          :text="isLoadingDownload ? $t('global.processing') : $t('global.action.download')"
          :icon="isLoadingDownload ? undefined : 'icon-outline_download'"
          :loading="isLoadingDownload"
          @click="handleClickDownloadVideo"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'

export default {
  name: 'VideoSuccess',
  components: { McButton },
  mixins: [Helper, MixPanel],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    convertedChannel: {
      type: [String, Number],
      required: true,
    },
    deviceTimezone: {
      type: [String, Number],
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    endTime: {
      type: String,
      required: true,
    },
    downloadOn: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    mediaFilename: {
      type: String,
      required: true,
    },
    isVideoDemo: {
      type: Boolean,
      default: false,
    },
    downloadId: {
      type: Number,
      required: true,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoadingDownload: false,
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      hasAccess: 'identity/hasAccess',
    }),
  },
  methods: {
    handleClickShowVideo() {
      if (this.isVideoDemo) {
        window.sessionStorage.setItem(
          'tv2VideoHistoryDemoData',
          JSON.stringify([
            {
              licensePlate: this.licensePlate,
              convertedChannel: this.convertedChannel,
              startTime: this.startTime,
              endTime: this.endTime,
              downloadOn: this.downloadOn,
              status: 'S',
              deviceTimezone: 7,
              downloadId: this.downloadId,
              url: this.url,
            },
          ])
        )
      }
      const isMenuTrackvision = this.hasAccessAll(['b3h-new-trackvision-menu:read'])
      const routeData = this.$router.resolve({
        name: isMenuTrackvision ? 'Video History Trackvision Download' : 'Video History 3 Download',
        query: {
          modalShowDownloadVideoId: this.downloadId,
          videoHistoryVehicleId: this.vehicleId,
          ...(this.isVideoDemo ? { isDemo: true } : {}),
        },
      })
      window.open(routeData.href, '_blank')
    },
    handleClickDownloadVideo() {
      this.track('Click Video History Download', {
        license_plate: this.$store.state.vehicle.vehicleDetail.licensePlate,
        filename: `${this.mediaFilename}`,
      })
      const hasAccessConvertVideo = this.hasAccess(['b3q-trackvision-convert-video-download:read'])
      if (hasAccessConvertVideo) {
        this.convertAndDownload()
      } else {
        this.directDownload()
      }
    },
    async convertAndDownload() {
      this.isLoadingDownload = true
      const path = this.extractPathFromDomain(this.url)
      try {
        const res = await fetch(process.env.VUE_APP_API_CONVERT_VIDEO + '/' + path, {
          method: 'GET',
        })
        if (!res.ok) throw new Error('Failed to fetch file')
        const blob = await res.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        let filename = this.mediaFilename
        const contentDisposition = res.headers.get('Content-Disposition')
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1]
          }
        }
        this.downloadFile(downloadUrl, filename)
      } catch (error) {
        this.$mcToast.error('Failed convert video')
      } finally {
        this.isLoadingDownload = false
      }
    },
    directDownload() {
      if (this.isVideoDemo) return
      this.downloadFile(this.url, this.mediaFilename)
    },
  },
}
</script>
